define.alias("ember-cli-string-helpers/helpers/trim", "media/helpers/trim");